module.exports = __webpack_public_path__ + "static/bg320-840ace7d4e45a38d6506f72fb2b997d1.jpg";